// The Sequences section's numbers. Each email records when it was first opened,
// so opens here are per email, and an open rate can't pass 100%.

const rate = (part, whole) => (whole ? part / whole : 0);

// sequenceReport returns the totals, and a row per sequence: most emails sent
// first, then by name.
export function sequenceReport(sequences) {
  const rows = (sequences || []).map((s) => ({
    id: s.sequence_id,
    name: s.name,
    status: s.status,
    active: s.active || 0,
    completed: s.completed || 0,
    cancelled: s.cancelled || 0,
    sent: s.sent || 0,
    opened: s.opened || 0,
    unsubscribed: s.unsubscribed || 0,
    openRate: rate(s.opened || 0, s.sent || 0),
  })).sort((a, b) => b.sent - a.sent || (a.name || "").localeCompare(b.name || ""));

  const total = (field) => rows.reduce((sum, r) => sum + r[field], 0);
  return {
    rows,
    sequences: rows.length,
    running: rows.filter((r) => r.status === "active").length,
    inProgress: total("active"),
    finished: total("completed"),
    sent: total("sent"),
    opened: total("opened"),
    unsubscribed: total("unsubscribed"),
    openRate: rate(total("opened"), total("sent")),
  };
}
